export { GoodsCard as ProductCard } from './ui/Card';
export { getFullProductProps } from './lib/getFullProductProps';
export { getProductInitialOptions } from './lib/getProductInitialOptions';

export * from './model/IGood';
